import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { PriceOptionToggleControlComponent } from './price-option-toggle-control.component';

@NgModule({
  declarations: [
    PriceOptionToggleControlComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    PriceOptionToggleControlComponent,
  ],
  entryComponents: [
    PriceOptionToggleControlComponent
  ],
})
export class PriceOptionToggleControlModule { }
